import { render, staticRenderFns } from "./ConfigDialog.vue?vue&type=template&id=977a6432&scoped=true&"
import script from "./ConfigDialog.vue?vue&type=script&lang=js&"
export * from "./ConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDialog.vue?vue&type=style&index=0&id=977a6432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977a6432",
  null
  
)

export default component.exports